import { gql } from '@edreamsodigeo/frontend-api-client';

export const api = gql`
  fragment SectionLocation on Location {
    id
    iata
    cityIata
    cityName
    name
    countryName
    locationType
  }
`;
